// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MailGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M47.82 42.174H9.182c-.766 0-1.39-.623-1.39-1.39V15.548l13.904 12.128-7.993 7.496a1.166 1.166 0 1 0 1.596 1.702l8.165-7.657 2.344 2.045a4.094 4.094 0 0 0 2.693.987c.97 0 1.938-.33 2.693-.987l2.347-2.046 8.162 7.658a1.163 1.163 0 0 0 1.649-.053c.44-.47.417-1.208-.053-1.649l-7.991-7.498L49.21 15.551v25.233c0 .767-.624 1.39-1.39 1.39ZM29.66 29.503c-.617.539-1.701.538-2.318 0L9.367 13.825h38.271L29.66 29.504Zm18.16-18.01H9.182a3.727 3.727 0 0 0-3.723 3.722v25.57a3.727 3.727 0 0 0 3.723 3.722H47.82a3.727 3.727 0 0 0 3.723-3.723V15.215a3.727 3.727 0 0 0-3.723-3.723Z"
			fill="url(#MailGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="MailGradient_tsx__a"
				x1={5.459}
				y1={11.492}
				x2={5.459}
				y2={44.507}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default MailGradient;
